import { ComponentProps } from "react";
import { RegisterOptions } from "react-hook-form";
import styled from "styled-components";
import { Input } from "@songtradr/design-language";

// TEXT

// STYLES
export const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 0.5rem;
  flex: 1;
`;

// DATA

// TYPES
export interface Props extends ComponentProps<typeof Input> {
  id: string; // make id required
  errorMessage?: string; // optional custom error message override
  registerOptions?: RegisterOptions;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
